import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import type { Article, Category } from '@/types';

export const getAllArticles = (): Article[] => articles as Article[];

export const getArticleById = (id: string): Article | undefined =>
  (articles as Article[]).find((item) => item.id === id);

export const getArticlesByCategory = (slug: string): Article[] =>
  (articles as Article[]).filter((item) => item.category === slug);

export const getHotArticles = (limit = 6): Article[] =>
  (articles as Article[])
    .filter((item) => item.hot)
    .slice(0, limit);

export const getFeaturedArticle = (): Article =>
  (articles as Article[]).find((item) => item.featured) || (articles as Article[])[0];

export const getLatestArticles = (limit = 6): Article[] =>
  (articles as Article[]).slice(0, limit);

export const getRelatedArticles = (article: Article, limit = 3): Article[] => {
  const sameCategory = (articles as Article[]).filter(
    (item) => item.category === article.category && item.id !== article.id,
  );
  if (sameCategory.length >= limit) {
    return sameCategory.slice(0, limit);
  }
  const others = (articles as Article[]).filter(
    (item) => item.category !== article.category && item.id !== article.id,
  );
  return [...sameCategory, ...others].slice(0, limit);
};

export const getCategories = (): Category[] => categories as Category[];

export const getCategoryBySlug = (slug: string): Category | undefined =>
  (categories as Category[]).find((item) => item.slug === slug);

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return `${views}`;
};

export const formatDateTime = (value: string): string => value;

export const buildArticlePath = (id: string): string => `/article/${id}`;

export const buildCategoryPath = (slug: string): string => `/category/${slug}`;